<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('能量余量监控.page_title') }}(SOC)</span>
            <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
                <el-form-item :label="$t('time.timeQuery')">
                    <el-date-picker v-model="form.queryDate" type="date" value-format="yyyy-MM-dd"
                        :placeholder="$t('龙翼简报.选择日期')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onQuery" type="primary">{{ $t('public.query') }}</el-button>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" @click="onExport">{{ $t('public.export') }}</el-button>
                </el-form-item> -->
            </el-form>
        </div>
        <el-divider></el-divider>
        <div class="page_container">
            <div v-if="chartDataList.length === 0" class="no-data">
                <KLInfo :title="$t('public.noData')" :desc="$t('public.selectDateAndVehicle')" />
            </div>
            <div v-else class="charts-wrapper">
                <div v-for="(item, index) in chartDataList" :key="index" class="vehicle-chart-container">
                    <div class="vehicle-info">
                        <span class="vehicle-name">{{ item.vehicleName }}</span>
                        <span class="vehicle-vin">{{ item.vin }}</span>
                    </div>
                    <div :ref="`chart-${index}`" class="chart-content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import * as echarts from 'echarts';
import { mapState } from 'vuex'
import language from '@/utils/getLanguageId'
import settings from "@/settings";
import { queryVehicle32960Data } from "@/http/vehicle";
import KLInfo from '@/components/KLInfo.vue';
export default {
    name: "socChange",
    components: {
        KLInfo
    },
    data() {
        return {
            loading: false,
            form: {
                queryDate: this.getTodayDate(),
                PageNo: 1,
                PageSize: 65535
            },
            LanguageId: 1,
            charts: [], // 存储多个图表实例
            chartDataList: [] // 存储每辆车的数据
        }
    },
    computed: {
        size() {
            return this.$store.getters.size
        },
        ...mapState({
            selectedVehicles: state => state.app.vehicles.selectedVehicles,
        }),

    },
    mounted() {
        const currentPath = this.$route.path
        // 从全局变量中取出对应路由的开始时间
        const startTime = settings.routeStartTime[currentPath]
        if (startTime) {
            // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
            const renderTime = Date.now() - startTime
            console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
            // 可选：上报到后端或日志系统
            // reportRenderTime(currentPath, renderTime)

            // 清除已计算的开始时间，避免重复计算
            delete settings.routeStartTime[currentPath]
        }
        this.LanguageId = language(this.$store.getters.locale)

        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        // 销毁所有图表实例
        this.charts.forEach(chart => {
            if (chart) chart.dispose();
        });
        this.charts = [];
    },
    methods: {
        getTodayDate() {
            //往前退一天
            var date = new Date();
            date.setDate(date.getDate() - 1);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        onQuery() {
            this.queryChartData();
        },
        onExport() {
            this.queryChartData(1);
        },
        generatePieces(data) {
            const COLOR_UP = '#07B477';
            const COLOR_DOWN = '#FF106E';
            const COLOR_EQUAL = '#808080'; // 新增趋势不变时的灰色颜色
            const pieces = [];
            if (data.length <= 1) return pieces;

            let startIndex = 0;
            // 初始趋势判断
            let currentTrend;
            if (data[1] > data[0]) {
                currentTrend = 'up';
            } else if (data[1] < data[0]) {
                currentTrend = 'down';
            } else {
                currentTrend = 'equal';
            }

            for (let i = 1; i < data.length; i++) {
                let newTrend;
                if (data[i] > data[i - 1]) {
                    newTrend = 'up';
                } else if (data[i] < data[i - 1]) {
                    newTrend = 'down';
                } else {
                    newTrend = 'equal';
                }

                // 如果趋势发生变化
                if (newTrend !== currentTrend) {
                    let color;
                    if (currentTrend === 'up') {
                        color = COLOR_UP;
                    } else if (currentTrend === 'down') {
                        color = COLOR_DOWN;
                    } else {
                        color = COLOR_EQUAL;
                    }
                    pieces.push({
                        gt: startIndex,
                        lte: i - 1,
                        color: color
                    });
                    startIndex = i - 1;
                    currentTrend = newTrend;
                }
            }
            // 添加最后一个趋势区间
            let lastColor;
            if (currentTrend === 'up') {
                lastColor = COLOR_UP;
            } else if (currentTrend === 'down') {
                lastColor = COLOR_DOWN;
            } else {
                lastColor = COLOR_EQUAL;
            }
            pieces.push({
                gt: startIndex,
                lte: data.length - 1,
                color: lastColor
            });

            return pieces;
        },
        async queryChartData() {
        // console.log(this.selectedVehicles);
        // return;
            if (this.selectedVehicles.length === 0) {
                this.$message.warning(this.$t("vehicletrack.selectvehicle"));
                return;
            }
            
            if (!this.form.queryDate.length) {
                this.$message.error(this.$t("time.selectQueryTime"));
                return;
            }
            
            this.loading = true;
            this.chartDataList = [];
            
            // 销毁所有旧图表实例
            this.charts.forEach(chart => {
                if (chart) chart.dispose();
            });
            this.charts = [];
            
            try {
                // 串行请求多辆车的数据
                for (const vehicle of this.selectedVehicles) {
                    const res = await queryVehicle32960Data({
                        "vin": vehicle.vincode,
                        "startDate": this.form.queryDate + " 00:00:00",
                        "endDate": this.form.queryDate + " 23:59:59",
                        "pageNum": this.form.PageNo,
                        "language": this.LanguageId,
                        "pageSize": this.form.PageSize
                    });
                    
                    const data = res.data.list;
                    
                    // 处理每辆车的数据
                    if (data && data.length > 0) {
                        const socData = [];
                        const timeData = [];
                        
                        data.reverse();
                        let prevSOC = null;
                        data.forEach(element => {
                            if (prevSOC === null || element.SOC !== prevSOC) {
                                socData.push(element.SOC);
                                timeData.push(element.GpsDateTime.toString().substring(11, 16));
                                prevSOC = element.SOC;
                            }
                        });
                        
                        this.chartDataList.push({
                            vehicleName: vehicle.name || vehicle.vincode,
                            vin: vehicle.vincode,
                            socData,
                            timeData,
                            pieces: this.generatePieces(socData)
                        });
                    } else {
                        // 无数据情况
                        this.chartDataList.push({
                            vehicleName: vehicle.name || vehicle.vincode,
                            vin: vehicle.vincode,
                            socData: [],
                            timeData: [],
                            pieces: []
                        });
                    }
                }
                
                // 延迟创建图表，确保DOM已更新
                
                // 延迟创建图表，确保DOM已更新
                this.$nextTick(() => {
                    this.initCharts();
                });
            } catch (error) {
                console.error('查询SOC数据失败:', error);
                this.$message.error(this.$t('public.serverError'));
            } finally {
                this.loading = false;
            }
        },
        initCharts() {
            // 为每辆车创建独立的图表
            this.chartDataList.forEach((item, index) => {
                const chartDom = this.$refs[`chart-${index}`][0];
                if (chartDom) {
                    const chart = echarts.init(chartDom);
                    this.charts.push(chart);
                    
                    const option = {
                        title: {
                            show: false
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'cross'
                            },
                            formatter: function (params) {
                                const param = params[0];
                                return `
                                    <div style="font-weight: bold;">${param.name}</div>
                                    <div>SOC: ${param.data} %</div>
                                `;
                            }
                        },
                        toolbox: {
                            show: true,
                            feature: {
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: item.timeData
                        },
                        dataZoom: [
                            {
                                type: 'inside',    // 内置型
                                xAxisIndex: 0,     // 控制哪个 x 轴
                                start: 0,          // 初始显示数据的开始百分比（0-100）
                                end: 100,          // 初始显示数据的结束百分比
                                zoomOnMouseWheel: true,  // 鼠标滚轮缩放
                                moveOnMouseMove: true,   // 鼠标拖动平移
                            },
                            {
                                type: 'slider',    // 滑动条型
                                xAxisIndex: 0,     // 控制哪个 x 轴
                                start: 0,
                                end: 100,
                                height: 20,        // 滑动条高度
                                borderColor: 'transparent',  // 边框颜色
                                backgroundColor: '#f5f5f5',  // 背景颜色
                                fillerColor: 'rgba(156, 176, 195, 0.5)',  // 填充颜色
                                handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',  // 滑块图标
                                handleSize: '100%',  // 滑块大小
                            }
                        ],
                        yAxis: {
                            name: "SOC(%)",
                            type: 'value',
                            axisLabel: {
                                formatter: '{value} %'
                            },
                            min: 0,
                            max: 100,
                            axisPointer: {
                                snap: true
                            }
                        },
                        visualMap: {
                            show: false,
                            dimension: 0,
                            pieces: item.pieces
                        },
                        series: [
                            {
                                name: 'SOC',
                                type: 'line',
                                smooth: true,
                                 symbol: 'none',
                                // symbol: 'circle',
                                symbolSize: 4,
                                lineStyle: {
                                    width: 2
                                },
                                data: item.socData
                            }
                        ]
                    };
                    
                    chart.setOption(option);
                }
            });
        },
        handleResize() {
            // 调整所有图表大小
            this.charts.forEach(chart => {
                if (chart) {
                    chart.resize();
                }
            });
        }
    }
};
</script>

<style scoped>
.charts-wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 20px;
}

.vehicle-chart-container {
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.vehicle-info {
    padding: 12px 20px;
    background: #f5f7fa;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.vehicle-name {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.vehicle-vin {
    font-size: 14px;
    color: #606266;
}

.soc-container {
    padding: 20px;
}

.chart-content {
    width: 100%;
    height: 400px;
    min-height: 300px;
}

.no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    padding: 20px;
}
</style>